var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_2614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26138 0 0 4.26138 0 9.5C0 14.7386 4.26138 19 9.5 19C14.7386 19 19 14.7386 19 9.5C19 4.26138 14.7386 0 9.5 0ZM9.10415 15.8333C8.44932 15.8333 7.91665 15.3007 7.91665 14.6458C7.91665 13.991 8.44932 13.4583 9.10415 13.4583C9.75899 13.4583 10.2917 13.991 10.2917 14.6458C10.2917 15.3007 9.75899 15.8333 9.10415 15.8333ZM10.2917 11.0045V12.2708C10.2917 12.4896 10.1146 12.6667 9.89581 12.6667H8.3125C8.0937 12.6667 7.91665 12.4896 7.91665 12.2708V10.2917C7.91665 9.41884 8.62715 8.70835 9.5 8.70835C10.3728 8.70835 11.0833 7.99785 11.0833 7.125C11.0833 6.25215 10.3728 5.54165 9.5 5.54165C8.62715 5.54165 7.91665 6.25215 7.91665 7.125V7.52085C7.91665 7.73964 7.73961 7.91669 7.52081 7.91669H5.9375C5.7187 7.91669 5.54165 7.73964 5.54165 7.52085V7.125C5.54165 4.94249 7.31749 3.16665 9.5 3.16665C11.6825 3.16665 13.4583 4.94252 13.4583 7.125C13.4583 9.02455 12.1201 10.6342 10.2917 11.0045Z",
    fill: "#546EDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_2614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot7);
export default __webpack_public_path__ + "static/media/bot7.187a0dfe261164a9cc93eba9e3336c5c.svg";
export { ForwardRef as ReactComponent };